<template>
  <div class="productionData main-content">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('productionList.form.basicDetailInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            v-model="baseData"
            :options="options"
            ref="baseData"
            @input="handleChangeBaseData"
            label-width="100px"
          ></base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('productionList.form.basicDetailPct') }}
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="table"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :columns="column"
            :edit-rules="rules"
            :max-height="$store.state.app.tableHeight"
            :toolbar="{}"
            :valid-config="{ autoPos: true, message: 'inline' }"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="insertEvent(-1)"
                type="primary"
                icon="el-icon-plus"
                :disabled="buttonStatus()"
                class="vxe-btn-primary"
                >{{ $t('functionBtn.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete()"
                type="primary"
                icon="el-icon-delete"
                :disabled="buttonStatus()"
                class="vxe-btn-delete"
                >{{ $t('functionBtn.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="fixed-bottom-btnList">
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815192381367']"
        :disabled="this.baseData.productStatus === '001' ? true : false"
        @click="handleSave('ZT06')"
        >{{ $t('rawData.buttons.save') }}</el-button
      >
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815210270435']"
        :disabled="this.baseData.productStatus === '001' ? true : false"
        @click="handleSave('ZT02')"
        >{{ $t('rawData.buttons.submit') }}</el-button
      >
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815211180899']"
        :disabled="this.baseData.productStatus === '001' ? false : true"
        @click="handleSave('ZT03')"
        >{{ $t('rawData.buttons.revert') }}</el-button
      >
    </footer>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import API from '@/api/productCenter/rawData';
  import { mapState } from 'vuex';
  // import { dateFormat } from '@/filters';
  // import loading from '@/common/js/load.js';
  // import SearchTable from '@/components/form-item/search-table';
  export default {
    name: 'productionDataAdd',
    components: {
      baseForm,
      // SearchTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      routerData() {
        return this.$route.query;
      },
      options() {
        return [
          {
            type: 'input',
            label: this.$t('productionList.label.companyName'),
            prop: 'companyName',
            required: true,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('productionList.label.departmentName'),
            prop: 'departmentName',
            required: true,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('productionList.label.createBy'),
            prop: 'createBy',
            required: true,
            disabled: true,
          },
          {
            type: 'date',
            label: this.$t('productionList.label.gmtCreate'),
            prop: 'gmtCreate',
            placeholder: this.$t('placeholder.auto'),
            disabled: true,
          },
          {
            type: 'dict',
            dictType: 'produce_product_status',
            label: this.$t('productionList.label.productStatus'),
            prop: 'productStatus',
            placeholder: this.$t('placeholder.auto'),
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('productionList.label.productCode'),
            prop: 'productCode',
            placeholder: this.$t('placeholder.auto'),
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('productionList.label.productName'),
            prop: 'productName',
            required: true,
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          {
            type: 'dict',
            dictType: 'product_type',
            label: this.$t('productionList.label.productCategory'),
            prop: 'productCategory',
            required: true,
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          //   品牌
          {
            type: 'input',
            label: this.$t('productionList.label.productBrand'),
            prop: 'productBrand',
            required: false,
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          //   规格型号
          {
            type: 'input',
            label: this.$t('productionList.label.productSpec'),
            prop: 'productSpec',
            required: true,
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          //   项目名称
          {
            type: 'dict',
            dictType: 'produce_product_proname',
            label: this.$t('productionList.label.projectName'),
            prop: 'projectCode',
            required: true,
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          //   其他
          {
            type: 'input',
            label: this.$t('productionList.label.otherInfo'),
            prop: 'otherInfo',
            disabled: this.baseData.productStatus === '001' ? true : false,
          },
          //   配方编号
          {
            type: 'searchTable',
            label: this.$t('productionList.label.formulaNo'),
            prop: 'formulaNo',
            required: false,
            searchType: 'produceFurmula',
            isMultiple: true,
            extraData: {
              statusFlag: '001',
            },
            disabled: this.baseData.productStatus === '001' ? true : false,
            currentValue: this.baseData.formulaNo, //用于回显展示
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            type: 'seq',
            width: 80,
            title: this.$t('productionList.table.projectCode'),
          },
          {
            field: 'productName',
            title: this.$t('productionList.table.productConfirmName'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productSpec',
            title: this.$t('productionList.table.confimProductNameSpec'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productCategory',
            title: this.$t('productionList.table.confimProductCategory'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productBrand',
            title: this.$t('productionList.table.confimProductBrand'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'otherInfo',
            title: this.$t('productionList.table.confimOtherInfo'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      rules() {
        return {
          productName: [
            { required: true, message: this.$t('productionList.placeholder.productConfirmName') },
          ],
          productSpec: [
            {
              required: true,
              message: this.$t('productionList.placeholder.confimProductNameSpec'),
            },
          ],
          productCategory: [
            {
              required: true,
              message: this.$t('productionList.placeholder.confimProductCategory'),
            },
          ],
        };
      },
    },
    data() {
      return {
        activeNames: ['1', '2'], //默认展开所有面板
        tableData: [],
        baseData: {
          companyCode: null, // 公司
          companyName: null, // 公司名称
          departmentCode: null, // 部门
          departmentName: null, // 部门名称
          createBy: null, // 创建人
          gmtCreate: null, // 创建日期
          productClass: '1', // 0-原料，1-产品
          productStatus: null, // 数据状态
          productCode: null, // 原料编号
          productName: null, // 原料名称
          productType: null, // 主料/辅料
          productCategory: null, // 原料大类
          costType: null, // 成本类型
          projectCode: null, // 项目代码
          projectName: null, // 项目名称
          productBrand: null, //品牌
          productSpec: null, // 规格型号
          formulaNo: null, // 配方编号
          otherInfo: null, //其他
        },
        addRowObj: {
          productClass: '1',
          productName: null,
          productSpec: null,
          productBrand: null,
          productCategory: null,
          otherInfo: null,
        },
        selectIds: [], //选中删除的行项目
      };
    },
    mounted() {
      if (this.$route.name.indexOf('Add') != -1) {
        ['companyCode', 'companyName', 'departmentCode', 'departmentName'].map((item) => {
          return (this.baseData[item] = this.userInfo[item]);
        });
        this.baseData.createBy = this.userInfo.userName;
      }

      if (this.$route.query.id) {
        this.getData();
      }
    },
    methods: {
      buttonStatus() {
        return this.baseData.productStatus === '001' ? true : false;
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'projectCode') {
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }

        if (prop == 'formulaNo' && value.formulaNo) {
          this.baseData.formulaNo = value.formulaNo[0].formulaNo;
        }
      },
      // 返回表单数据
      exportBaseData(btnType) {
        this.baseData.productStatus = '002';
        if (btnType == 'ZT02') {
          let sign = false;

          this.$refs.baseData.$refs.ruleForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
      // 返回表格数据
      exportTableData() {
        this.baseData.productStatus = '002'; //001-生效，002-草稿
        const tableData = this.$refs.table.getTableData().fullData;
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      async handleSave(btnType) {
        // 保存时主数据状态为草稿，可以直接提交状态变为生效，撤销已生效的数据状态为草稿，草稿或无无状态才可编辑修改
        if (btnType === 'ZT03') {
          if (this.baseData.productStatus === '002') {
            return;
          }
          this.baseData.productStatus = '002';
          return;
        }
        let baseData = this.exportBaseData(btnType);
        let pdProductAliasList = await this.exportTableData();
        if (pdProductAliasList.length > 0) {
          for (let i = 0; i < pdProductAliasList.length; i++) {
            for (let j = i + 1; j < pdProductAliasList.length; j++) {
              if (
                pdProductAliasList[i].productName == pdProductAliasList[j].productName &&
                pdProductAliasList[i].productSpec == pdProductAliasList[j].productSpec &&
                pdProductAliasList[i].productCategory == pdProductAliasList[j].productCategory &&
                pdProductAliasList[i].productBrand == pdProductAliasList[j].productBrand &&
                pdProductAliasList[i].otherInfo == pdProductAliasList[j].otherInfo
              ) {
                this.baseData.productStatus = '002'; //001-生效，002-草稿
                return this.$message({
                  showClose: true,
                  message: this.$t('productionList.message.noRepeatColumn'),
                  type: 'error',
                });
              }
            }
          }
        }
        pdProductAliasList.forEach((item) => {
          item.productBrand = item.productBrand ? item.productBrand : null;
          item.otherInfo = item.otherInfo ? item.otherInfo : null;
        });
        if (baseData && pdProductAliasList) {
          this.baseData.createBy = this.userInfo.userCode;
          if (btnType === 'ZT02') this.baseData.productStatus = '001'; //001-生效，002-草稿
          let params = {
            ...baseData,
            pdProductAliasList,
          };
          if (this.$route.query.id) {
            params = {
              ...params,
              id: this.$route.query.id,
              delDetailIds: this.selectIds,
            };
          }
          this.loading.startLoading();
          let res = await this.$axios.post(API.ADD_PRODUCT, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.saveSussess'),
                type: 'success',
              });
              this.toList();
            } else {
              this.baseData.productStatus = '002'; //001-生效，002-草稿
              this.baseData.createBy = this.userInfo.userName;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          }
        }
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/production/productionDataAdd',
            name: 'productionDataAdd',
            meta: {
              keepAlive: true,
              title: this.$t('productionList.pages.productionDataAdd'),
            },
          },
          toPath: {
            path: '/production/productionDataList',
            name: 'productionDataList',
            meta: {
              keepAlive: false,
              title: this.$t('productionList.pages.productionDataList'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.table.validate().then(() => {
          let record = JSON.parse(JSON.stringify(this.addRowObj));
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      // 删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            for (let item of selectedList) {
              this.selectIds.push(item.id);
            }
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancelled'),
            });
          });
      },
      // 详情
      getData() {
        if (this.$route.query.id) {
          //修改界面
          let params = {
            id: this.routerData.id,
          };
          this.loading.startLoading();
          this.$axios.post(API.DETAIL_PRODUCT, params).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              let allDetail = res.data.data;
              this.tableData = allDetail.pdProductAliasList;
              let [basicInfo, receivablesInfo] = [this.baseData, this.$refs.table.tableData];
              let [basicKeys, receivableKeys] = [
                Object.keys(basicInfo),
                Object.keys(receivablesInfo),
              ];
              basicKeys.map((item) => {
                basicInfo[item] = allDetail[item];
              });
              this.$baseRequest.getPerson().then((res) => {
                basicInfo.createBy = res.find((item) => item.id == basicInfo.createBy).personName;
              });
              receivableKeys.map((item) => {
                receivablesInfo[item] = allDetail[item];
              });
            }
          });
        }
      },
    },
  };
</script>
